import { css } from 'styled-components'

export const backgroundTransition = css`
  transition: background 0.2s cubic-bezier(0.22, 1, 0.36, 1);
`
